if (!String.prototype.ex) {
	String.prototype.ex = function (sep, id, mode) {
		if (id > 0) {
			if (!mode) {
				return this.split(sep)[id - 1] || '';
			} else {
				var v = this.split(sep).splice(id - 1, 9999)
				if (v) return v.join(sep);
			}
		}
		return '';
	}
}

if (!String.format) {
	String.format = function (format) {
		var args = Array.prototype.slice.call(arguments, 1);
		return format.replace(/{(\d+)}/g, function (match, number) {
			return typeof args[number] != 'undefined'
			? args[number]
			: match
			;
		});
	};
}
if (!String.prototype.var) {
	String.prototype.var = function (name, sep) {
		if (!sep) sep = ';';
		if (name) {
			name = name.toLowerCase();
			var v = this.split(sep);

			for (var i = 0; i < v.length; i++) {
				var q = v[i].indexOf('=');
				if (q > 0) {
					var n = v[i].substr(0, q).toLowerCase();
					if (n == name) {
						return v[i].substr(q + 1, 9999);
					}
				}
			}
		}
		return '';
	};
}
if (!String.prototype.setvar) {
	String.prototype.setvar = function (name, value, sep) {
		if (!sep) sep = ';';
		if (name) {
			name = name.toUpperCase();
			var v = this.split(sep);
			for (var i = 0; i < v.length; i++) {
				var q = v[i].indexOf('=');
				if (q > 0) {
					var n = v[i].substr(0, q).toUpperCase();
					if (n == name) {
						if (value) {
							v[i] = name + '=' + value;
						} else {
							v.splice(i, 1);
						}
						return v.join(sep);

					}
				}
			}
		}
		if (value)
			return this + sep + name + "=" + value;
		return this;
	};
}

if (!String.prototype.insert) {
	String.prototype.insert = function (insert, sep, pos) {
		if(insert==0) insert = '0';
		else insert=insert || '';
		pos--;
		if (pos<0) return this;
		let v=this.split(sep);
		for (let i=v.length;i<=pos;i++) v.push('');
			v[pos]=insert;
		return v.join(sep);
	}
}
if (!String.prototype.skipVariant) { //exclude from the string all the variants beginning with a prefix
    String.prototype.skipVariant = function (prefix, sep) {
        if (!prefix) return this;
        if (!sep) return this;
        v = this.split(sep);
        var vris = [];
        for (i = 0; i < v.length; i++) {
            var found = false;
            for (var j = 0; j < prefix.length; j++) {
                if (prefix[j].toUpperCase() == v[i].ex('=', 1).toUpperCase()) {
                    found = true;
                }
            }
            if (!found) {
                vris.push(v[i]);
            }
        }
        return vris.join(sep);
    }
}

if (!String.prototype.trim) {
	String.prototype.trim = function () {
		return this.replace(/^\s+|\s+$/g, '');
	};
};

String.prototype.toTitleCase = function (str) {
	var str = this || '';
	return str.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
};

if (!String.prototype.startsWith) {
	String.prototype.startsWith = function (searchString, position) {
		position = position || 0;
		return this.indexOf(searchString, position) === position;
	};
}

if (!Array.prototype.indexOf) {
	Array.prototype.indexOf = function (item) {
		var i = this.length;
		while (i--) {
			if (this[i] === item) return i;
		}
		return -1;
	};
}
if (!Date.prototype.toInt) {
	Date.prototype.toInt = function () {
		return this.getDate() + (this.getMonth() + 1) * 100 + this.getFullYear() * 10000
	}
}
if (!Date.prototype.toDouble) {
    Date.prototype.toDouble = function () {
        return this.getDate() + (this.getMonth() + 1) * 100 + this.getFullYear() * 10000 + this.getHours() * 0.01 + this.getMinutes() * 0.0001 + this.getSeconds() * 0.000001
    }
}
function escapeRegExp(str) {
	return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
String.prototype.replaceAll = function (find, replace) {
	var str = this || '';
	return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
};

if (Array.prototype.keySort == null) {
	Array.prototype.keySort = function (keys) {

		keys = keys || {};

		var obLen = function (obj) {
			var size = 0,
				key;
			for (key in obj) {
				if (obj.hasOwnProperty(key))
					size++;
			}
			return size;
		};

		var obIx = function (obj, ix) {
			var size = 0,
				key;
			for (key in obj) {
				if (obj.hasOwnProperty(key)) {
					if (size == ix)
						return key;
					size++;
				}
			}
			return false;
		};

		var keySort = function (a, b, d) {
			d = d !== null ? d : 1;
			if (typeof a === "string" && typeof b === "string") {
				a = a.toLowerCase(); // this breaks numbers
				b = b.toLowerCase();
			}
			if (a == b)
				return 0;
			return a > b ? 1 * d : -1 * d;
		};

		var KL = obLen(keys);

		if (!KL)
			return this.sort(keySort);

		for (var k in keys) {
			// asc unless desc or skip
			keys[k] =
				keys[k] == 'desc' || keys[k] == -1 ? -1 :
					(keys[k] == 'skip' || keys[k] === 0 ? 0 :
						1);
		}

		this.sort(function (a, b) {
			var sorted = 0,
				ix = 0;

			while (sorted === 0 && ix < KL) {
				var k = obIx(keys, ix);
				if (k) {
					var dir = keys[k];
					sorted = keySort(a[k], b[k], dir);
					ix++;
				}
			}
			return sorted;
		});
		return this;
	};
}

if (Array.prototype.inArray == null) {
	Array.prototype.inArray = function (comparer) {
		for (var i = 0; i < this.length; i++) {
			if (comparer(this[i])) return true;
		}
		return false;
	};
}
if (Array.prototype.pushIfNotExist == null) {
	Array.prototype.pushIfNotExist = function (element, comparer) {
		if (!this.inArray(comparer)) {
			this.push(element);
		}
	};
}


/*let pippo = function() {
    console.log(this);
    /!*if(!this)
        return;

    return Object.keys(this).reduce( (str, key, i) => {
        let delimiter, val;
        delimiter = (i === 0) ? '?' : '&';
        key = encodeURIComponent(key);
        val = encodeURIComponent(this[key]);
        return [str, delimiter, key, '=', val].join('');
    }, '');*!/
};
if (Object.prototype.pippo == null) {
    Object.prototype.pippo = pippo
}*/

export default {}
export function fromObjToQueryStr(obj) {
    return Object.keys(obj).reduce( (str, key, i) => {
        let delimiter, val;
        delimiter = (i === 0) ? '' : '&';
        key = encodeURIComponent(key);
        val = encodeURIComponent(obj[key]);
        return [str, delimiter, key, '=', val].join('');
    }, '');
}



// WEBPACK FOOTER //
// ./src/_eng/store/prototypes.js